import { useTranslation } from "react-i18next";

import type { Vacation } from "@/api/queries";
import { formatDayMonth } from "@/lib/format";

/** "с 16 сент. по 23 сент." / "с 16 сент., дата выхода не указана". */
export function useVacationText(): (v: Vacation) => string {
  const { t, i18n } = useTranslation();
  const lang = i18n.resolvedLanguage ?? "ru";
  return (v) =>
    v.until
      ? t("vacations.range", { from: formatDayMonth(v.from, lang), until: formatDayMonth(v.until, lang) })
      : t("vacations.rangeOpen", { from: formatDayMonth(v.from, lang) });
}
